// extracted by mini-css-extract-plugin
export default {"responsivePlaceholder":"NameInput_responsivePlaceholder__mU8Ay"};